<div #wafOutlet></div>
